export default {
  data() {
    return {
      dialog: false,
      saleId: null,
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    loading() { return this.$store.state.loading; },
    sales() { return this.$store.state.sales.sales; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { return this.$store.getters.isDealer; },
    isApproved() { return !!(this.$store.getters.isApproved); },
  },
  methods: {
    GetUnit({ product }) {
      return (product.unit && product.unit.short_name)
        ? product.unit.short_name
        : 'ед';
    },
    OpenDialog(id) {
      this.saleId = id;
      this.dialog = true;
    },
    CloseDialog() {
      this.saleId = null;
      this.dialog = false;
    },
    GetList() {
      this.$store.dispatch('sales/GetSalesList', {
        profile_id: this.user.profile_id,
        period_id: null,
      });
    },
    async RemoveSale() {
      if (this.saleId) {
        await this.$store.dispatch('sales/DeleteSale', {
          profile_id: this.user.profile_id,
          sale_id: this.saleId,
        })
          .then(async () => { await this.GetList(); })
          .finally(() => this.CloseDialog());
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },
  },
  mounted() {
    this.GetList();
  },
};
